import { teamsClient } from '@atlaskit/teams-client';

import { type TeamsPermissions } from '../../hooks/use-team-visibility';
import type { StoreApi, TeamAppState as TeamState } from '../../types';

export const removeAgentState = (
	teamState: TeamState,
	memberId: string,
	permissions?: Partial<TeamsPermissions>,
): TeamState => {
	const { teamProfile, teamAgents } = teamState;
	const teamId = teamProfile.teamId;

	const finalAgents = {
		...teamAgents,
		teamId,
		hasLoaded: true,
		hasError: false,
		isLoading: false,
		errorType: null,
		members: teamAgents.members.filter((agent) => !!agent.user && agent.user.id !== memberId),
	};

	return {
		...teamState,
		teamAgents: finalAgents,
	};
};

export const removeTeamAgent =
	(teamId: string, agentAtlassianAccountId: string, permissions?: Partial<TeamsPermissions>) =>
	async ({ getState, setState }: StoreApi) => {
		const state = getState();
		const removeMembershipResponse = await teamsClient.removeTeamMemberships(teamId, [
			{
				accountId: agentAtlassianAccountId,
			},
		]);

		// as we only removing 1 member at a time, it is safe to say task failed with even 1 error
		if (removeMembershipResponse.errors && removeMembershipResponse.errors.length) {
			throw Error('Membership claims to be removed but was not');
		}

		if (state.teamMembers.teamId !== teamId) {
			return;
		}

		const nextState = removeAgentState(state, agentAtlassianAccountId, permissions);
		setState(nextState);
	};
